import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import avatar from "assets/img/faces/marc.jpg";
import CustomTabs from "components/CustomTabs/CustomTabs";
import ThreeButtons from "./Components/ThreeButtons"
// Icons
import Dashboard1 from "@material-ui/icons/Dashboard";
import LockIcon from "@material-ui/icons/Lock";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import {  TextField, Tooltip, Typography } from "@material-ui/core";
import Switch from '@material-ui/core/Switch';
import { Android, AndroidOutlined, AndroidSharp, ContactSupport, PlayArrow, PlayCircleFilled, WarningOutlined } from "@material-ui/icons";
import ToggleButtonsPrecentSmall from "views/UserProfile/PageParts/ToggleButtonPrecentSmall";
import SearchBoxDca from "./Components/SearchBoxDca";
import ToogleThings from "views/UserProfile/PageParts/ToogleThings";
import ChartistGraph from "react-chartist";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};


import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts.js";
import ToggleButtons from "views/UserProfile/PageParts/ToggleButtons";
import ToggleButtonSmallXS from "./Components/ToggleButtonSmallXS";
import TransitionsModal from "./Components/ModalTable";
import SearchBox from "./Components/SearchBoxDca";


const useStyles = makeStyles(styles);

export default function UserProfile() {
  const classes = useStyles();

                                                // ShowHide Things
    // const [TradingViewComponent,ToggleThingsComponent] = ToogleThings(
      
    // );

  
  return (
    <div>

      <GridContainer style={{backgroundColor:"#00acc1",borderRadius:"10px",}}>
        <GridItem xs={6} sm={6} md={6} >
        <p>2 days left in your trial period.</p>
        </GridItem>
        
        <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
              <Button style={{border:"1px solid white"}} type="button" color="info">Buy Subscription</Button>
        </GridItem>
      </GridContainer>

      <GridContainer  >

      <GridItem xs={12} sm={12} md={6} style={{marginBottom:"-1.3rem",}}>
          <CustomTabs 
            // title="Tasks:"
            headerColor="primary"
            tabs={[
              
              {
                tabName: "Discover a bot",
                tabIcon: Android,
                tabPath: "/myexchanges",
                component: Typography,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[0, 3]}
                //     tasksIndexes={[0, 1, 2, 3]}
                //     tasks={bugs}
                //   />
                // )
              },
              {
                tabName: "My Bots",
                tabIcon: Android,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[0]}
                //     tasksIndexes={[0, 1]}
                //     tasks={website}
                //   />
                // )
              },
              {
                tabName: "Bot Analystics",
                tabIcon: Android,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[1]}
                //     tasksIndexes={[0, 1, 2]}
                //     tasks={server}
                //   />
                // )
              }
            ]}
          />
        </GridItem>
                                                {/* How it Works */}
        <GridItem md={12}>
          <PlayCircleFilled />
          <a id="advancedtexes" style={{marginLeft:"7px", color:"#66ccc7"}} href="#" >How It Works</a>
        </GridItem>

        <GridContainer md={12} sm={12} xs={12} style={{paddingTop:"5px"}}> 
          <GridItem xs={12} sm={12} md={12} style={{marginBottom:"-2.3rem",}}>
            <CustomTabs 
              // title="Tasks:"
              headerColor="primary"
              tabs={[
                
                {
                  tabName: "Gordon",
                  
                  // tabIcon: Dashboard1,
                  tabContent: (                          
                                                          // 1st Tab
                                                        // Gordon part
                    
                    <GridContainer style={{background:"white", marginLeft:"10px"}} md={12} sm={12} xs={12}> 
                      <GridContainer id="apiboxleftside" md={12} sm={12} xs={12}>
                        <GridItem style={{marginLeft:"px"}} md={4} sm={10} xs={12}>

                          <GridContainer style={{height:"40px", paddingLeft:"10px" }}>

                            <GridItem>
                              <p id="advancedtexes">Exchange</p>
                            </GridItem>

                            <GridItem style={{marginLeft:"-30px"}}>
                              <Tooltip 
                                placement="top" 
                                title="The bot will do trading on this exchange account" 
                                arrow >
                                <ContactSupport style={{ width:"20px"}}/>
                              </Tooltip>  
                            </GridItem>
                          </GridContainer>
                          <TextField style={{width:"330px", paddingLeft:"10px"}} variant="outlined"/>
                          {/* <FormControl variant="outlined" className={classes.formControl}>
                          <InputLabel id="demo-simple-select-outlined-label">Demo</InputLabel>
                            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              // value={age}
                              // onChange={handleChange}
                              label="Age"
                            >
                              <MenuItem value="">
                                <em>Demo</em>
                              </MenuItem>
                              <MenuItem value={10}>Ten</MenuItem>
                              <MenuItem value={20}>Twenty</MenuItem>
                              <MenuItem value={30}>Thirty</MenuItem> 
                            </Select>
                          </FormControl> */}

                        </GridItem>

                        <GridItem md={4} sm={10} xs={12}>
                        <p id="advancedtexes" style={{marginBottom:"1px",paddingLeft:"10px"}}>Quote currency</p>
                        <SearchBoxDca/>
                        
                        
                        {/* <FormControl  variant="outlined" className={classes.formControl}>
                          <InputLabel id="demo-simple-select-outlined-label">USDT</InputLabel>
                            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              // value={age}
                              // onChange={handleChange}
                              label="Market"
                            >
                              <MenuItem value="">
                                <em>asd</em>
                              </MenuItem>
                              <MenuItem value={10}>BTC</MenuItem>
                              <MenuItem value={20}>ETH</MenuItem>
                              <MenuItem value={30}>GBP</MenuItem>
                            </Select>
                          </FormControl> */}
                        </GridItem>

                        <GridItem id="apiboxtextkey" md={4} sm={10} xs={12}>
                        <p id="advancedtexes" style={{marginBottom:"1px",paddingLeft:"10px"}}>Amount</p>
                        <TextField style={{width:"350px",paddingLeft:"10px"}} md={12} sm={12} xs={12} variant="outlined"/>
                        <GridItem style={{marginTop:"15px", paddingLeft:"5px"}}>
                        <ToggleButtonsPrecentSmall  />
                        </GridItem>
                        {/* <FormControl variant="outlined" className={classes.formControl}>
                          <InputLabel  id="demo-simple-select-outlined-label">Trading Pair</InputLabel>
                            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              // value={age}
                              // onChange={handleChange}
                              label="Age"
                            >
                              <MenuItem value="">
                                <em>Trading Pair</em>
                              </MenuItem>
                              <MenuItem value={10}>Ten</MenuItem>
                              <MenuItem value={20}>Twenty</MenuItem>
                              <MenuItem value={30}>Thirty</MenuItem>
                            </Select>
                          </FormControl> */}
                        </GridItem>

                        
                        
                      </GridContainer> 

                      <GridContainer md={12} sm={10} xs={10}>
                        <GridItem style={{marginLeft:"20px"}} id="apiboxtextkey" md={12} sm={10} xs={12}>
                          <p id="advancedtexes" style={{marginBottom:"1px"}}>Bot settings</p>
                            <ThreeButtons />
                          
                          </GridItem>
                        </GridContainer>

                        <Card>
                          <Button type="button" color="info">Connect An Exchange</Button>
                        </Card>                              
                    </GridContainer>
                  ),
                },                               
                                                                  // 2nd Tab
                                                                // Advanced Tab
                {
                  tabName: "Advanced",
                  // tabIcon: LockIcon,
                  tabContent: (

                    <GridContainer id="ordersandpositions" md={12} sm={12} xs={12}>
                       <GridItem md={8} sm={12} xs={12}>  
                                                                    {/* Main Settings */}


                        <GridItem id="advanedmainsett" md={12} sm={12} xs={12}> 
                              
                              <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                                
                                <h4>Main settings</h4>

                                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                  {/* <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button> */}
                                  {/* <Switch onClick={ToggleHistoryComponent}/> */}
                                </GridItem>
                              </CardHeader>
                              <GridItem>
                                <p id="advancedtexes">Name</p>
                                <GridItem style={{marginLeft:"30px", marginTop:"-42px"}}>
                                  <Tooltip 
                                    placement="top" 
                                    title="A name for the bot which will help to determine the bot" 
                                    arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </GridItem>
                                <TextField id="advancedmaeinsettext" variant="outlined"></TextField>
                              </GridItem>

                                <GridContainer md={12}>
                                  <GridItem id="advancedmainsetexchange" md={8} >
                                    <p id="advancedtexes">Exchange</p>
                                    <GridItem style={{marginLeft:"50px", marginTop:"-42px"}}>
                                      <Tooltip 
                                        placement="top" 
                                        title="The bot will do trading on this exchange account" 
                                        arrow >
                                        <ContactSupport style={{ width:"20px"}}/>
                                      </Tooltip>  
                                    </GridItem>
                                    <TextField id="advancedmaeinsettextexchange" variant="outlined"></TextField>
                                  </GridItem>
                                  <GridItem id="advanedmainsetexchangebuttons" md={4} xs={12}>
                                    <p id="advancedtexes" style={{marginBottom:"5px"}}>Bot Type</p>
                                    <ToggleButtonSmallXS/>
                                  </GridItem>
                                </GridContainer>    
                              <GridItem>
                              </GridItem>
                                {/* {HistoryComponent} */}
                              
                        </GridItem>
                                                                     {/* Pairs */}

                        <GridItem id="advanedmainsett" md={12} sm={12} xs={12}> 
                              
                              <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                                
                                <h4>Pairs</h4>

                                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                  {/* <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button> */}
                                  {/* <Switch onClick={ToggleHistoryComponent}/> */}
                                </GridItem>
                              </CardHeader>
                              <GridItem>
                                <p id="advancedtexes">Pairs</p>
                                <GridItem style={{marginLeft:"20px", marginTop:"-42px"}}>
                                  <Tooltip 
                                    placement="top" 
                                    title="The bot will trade these coins" 
                                    arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </GridItem>
                                <SearchBox style={{ width:"500px !important"}}/>
                              </GridItem>
                                {/* {HistoryComponent} */}
                              
                        </GridItem>
                                                                     {/*Strategy */}

                        <GridItem id="advanedmainsett" md={12} sm={12} xs={12}> 
                              
                              <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                                
                                <h4>Strategy</h4>

                                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                  {/* <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button> */}
                                  {/* <Switch onClick={ToggleHistoryComponent}/> */}
                                </GridItem>
                              </CardHeader>
                 
                              <GridItem>
                                <p id="advancedtexes">Pairs</p>
                                <GridItem style={{marginLeft:"20px", marginTop:"-42px"}}>
                                  <Tooltip 
                                    placement="top" 
                                    title="The bot will trade these coins" 
                                    arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </GridItem>
                                <TextField variant="outlined"></TextField>
                              </GridItem>
                                {/* {HistoryComponent} */}
                              
                        </GridItem>
                                                              {/* Safety orders */}

                        <GridItem id="advanedmainsett" md={12} sm={12} xs={12}> 
                              
                              <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                                
                                <h4>Safety orders</h4>

                                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                  {/* <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button> */}
                                  {/* <Switch onClick={ToggleHistoryComponent}/> */}
                                </GridItem>
                              </CardHeader>
                              <GridItem>
                                <p id="advancedtexes">Pairs</p>
                                <GridItem style={{marginLeft:"20px", marginTop:"-42px"}}>
                                  <Tooltip 
                                    placement="top" 
                                    title="The bot will trade these coins" 
                                    arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </GridItem>
                                <TextField variant="outlined"></TextField>
                              </GridItem>
                                {/* {HistoryComponent} */}
                              
                        </GridItem>
                                                            {/* Advanced settings */}

                        <GridItem id="advanedmainsett" md={12} sm={12} xs={12}> 
                              
                              <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                                
                                <h4>Advanced settings</h4>

                                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                  {/* <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button> */}
                                  {/* <Switch onClick={ToggleHistoryComponent}/> */}
                                </GridItem>
                              </CardHeader>
                              <GridItem>
                                <p id="advancedtexes">Pairs</p>
                                <GridItem style={{marginLeft:"20px", marginTop:"-42px"}}>
                                  <Tooltip 
                                    placement="top" 
                                    title="The bot will trade these coins" 
                                    arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </GridItem>
                                <TextField variant="outlined"></TextField>
                              </GridItem>
                                {/* {HistoryComponent} */}
                              
                        </GridItem>  
                                                           {/* Take profit */}

                        <GridItem id="advanedmainsett" md={12} sm={12} xs={12}> 
                              
                              <CardHeader md={12} sm={12} xs={12} style={{marginLeft:"-19px"}} color="primary" stats>
                                
                                <h4>Take profit</h4>

                                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-38px", float:"right", marginRight:"-35px"}}>
                                  {/* <Button id="filterbutton" size="small" ><LayersClear id="filtericon"/>Clear Filters</Button> */}
                                  {/* <Switch onClick={ToggleHistoryComponent}/> */}
                                </GridItem>
                              </CardHeader>
                              <GridItem>
                                <p id="advancedtexes">Pairs</p>
                                <GridItem style={{marginLeft:"20px", marginTop:"-42px"}}>
                                  <Tooltip 
                                    placement="top" 
                                    title="The bot will trade these coins" 
                                    arrow >
                                    <ContactSupport style={{ width:"20px"}}/>
                                  </Tooltip>  
                                </GridItem>
                                <TextField variant="outlined"></TextField>
                              </GridItem>
                                {/* {HistoryComponent} */}
                        </GridItem>                                      

                      </GridItem>

                      

                                                      {/* Right side tabs (1 Assistant/2 Chart/3 Table) */}
                                                                          
                      <GridContainer xs={12} sm={12} md={4} style={{marginBottom:"-1.3rem", }}>
                        <CustomTabs id="advancedrightpartheader"  
                          // title="Tasks:"
                          headerColor="primary"
                          tabs={[
                            
                            {
                              tabName: "Assistant",
                              // tabIcon: Android,
                              tabPath: "/myexchanges",
                              component: Typography,
                              tabContent: (
                                                                        // Assistant
                                <GridItem xs={12} sm={12} md={12}> 
                                  {/* <Card> */}
                                    {/* <CardHeader id="popularheader" color="primary">
                                      <h4 className={classes.cardTitleWhite}>USDT_OMG</h4>
                                      <p className={classes.cardCategoryWhite}>
                                        New employees on 15th September, 2016
                                      </p>
                                    </CardHeader> */}
                                    <CardBody>
                                      
                                      <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid rgb(222 222 222 / 87%)"}}>
                                        <GridItem xs={6} sm={6} md={6} >
                                        <GridContainer style={{height:"px", paddingLeft:"px" }}>
                                          <GridItem id="advancedrightsidepopulartext">
                                            <p >Max amount for bot usage (Based on current rate)</p>
                                          </GridItem>

                                          <GridItem style={{marginLeft:"120px", marginTop:"-42px"}}>
                                            <Tooltip 
                                              placement="top" 
                                              title="It is an approximate calculation with current market rates. 
                                              The real price of safety orders may differ too.
                                               The reason is that exchanges have price and volume step limitations for orders, 
                                               and the calculation doesn't include these limits. 
                                               The bot itself includes all these limits and trades with them considered." 
                                              arrow >
                                              <ContactSupport style={{ width:"20px"}}/>
                                            </Tooltip>  
                                          </GridItem>
                                        </GridContainer>
                                          <p id="advancedrightsidepopulartext">Max safe order price deviation</p>
                                          <p id="advancedrightsidepopulartext">% of available balance to be used by the bot</p>
                                          {/* <p id="populartext">StopLoss</p>
                                          <p id="populartext">Last edited</p> */}
                                        </GridItem>
                                    
                                        <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                                          <p id="advancedrightsidepopularsecondtext"  className={classes.cardCategory}>
                                            <span className={classes.successText}>
                                            {/* <ArrowUpward className={classes.upArrowCardCategory} />  */}
                                            0.18 AAVE
                                            </span>{" "}
                                          </p>
                                          <p id="advancedrightsidepopularsecondtext">5%</p>
                                          <p id="advancedrightsidepopularsecondtext">0.00</p>
                                          {/* <p style={{color:"red"}} id="advancedrightsidepopularsecondtext">No</p>
                                          <p id="advancedrightsidepopularsecondtext">11/16/2020</p> */}
                                        </GridItem>

                                        <GridContainer style={{border: "1px solid #ff9800", borderRadius:"5px", marginLeft:"10px"}} md={12}>  
                                          <GridItem style={{marginTop:"10px"}} md={2} sm={2} xs={2}> 
                                          <WarningOutlined  style={{color:"#ff9800", width:"50px", height:"50px", borderRadius:"20px"}}/>                                      
                                          </GridItem>
                                          <GridItem md={10} sm={10} xs={10}> 
                                          <p>Warning! Bot will use amount greater than you have on exchange</p>
                                          </GridItem>
                                        </GridContainer>
                                      </GridContainer>

                                      <Card>
                                        <Button type="button" color="info">Start Now</Button>
                                      </Card>
                                    </CardBody>
                                  {/* </Card> */}
                                </GridItem>
                              //   <Tasks
                              //     checkedIndexes={[0, 3]}
                              //     tasksIndexes={[0, 1, 2, 3]}
                              //     tasks={bugs}
                              //   />
                              )
                            },
                                                                // Chart
                            {
                              tabName: "Chart",
                              // tabIcon: Android,
                              tabContent: (
                                <GridItem xs={12} sm={12} md={12}>
                                <Card chart>
                                                                  
                                  <CardHeader color="primary">
                                    <ChartistGraph 
                                      className="ct-chart"
                                      data={dailySalesChart.data}
                                      type="Line"
                                      options={dailySalesChart.options}
                                      listener={dailySalesChart.animation}
                                    />
                                  </CardHeader>
                                  {/* <CardBody id="topboxes" >
                                    <h4 style={{borderBottom: "1px solid #eee",  }} className={classes.cardTitle}>My DCA Bots<a href="http://localhost:3000/admin/dcabot"><Button style={{float:"right",width:"25px",height:"25px",marginTop:"-5px",background:"#47d3e4"}}><Add/></Button></a></h4>
                                    <p className={classes.cardCategory}>
                                      <span className={classes.successText}>
                                        <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                                      </span>{" "}
                                      A bot hasn't been created yet. Choose a strategy or copy another bot, use signals and get a profit.
                                    </p>
                                  </CardBody> */}
                                  <CardFooter chart>
                                    
                                    <div style={{color:"#579ee0",}} className={classes.stats}>
                                    {/* <a style={{textDecoration:"none", color:"#579ee0",}} href="#">
                                      <AccessTime /> 
                                      <PhotoSizeSelectSmallIcon/>
                                      Learn more about Bots
                                      </a> */}
                                    </div>
                                  </CardFooter>
                                </Card>
                              </GridItem>
                              //   <Tasks
                              //     checkedIndexes={[0]}
                              //     tasksIndexes={[0, 1]}
                              //     tasks={website}
                              //   />
                              )
                            },
                                              
                                                          // Table
                            {
                              
                              tabName: "Table",
                              
                              // tabIcon: Android,
                              tabContent: (
                                <GridItem>
                                <TransitionsModal/>
                                </GridItem>
                              //   <Tasks
                              //     checkedIndexes={[1]}
                              //     tasksIndexes={[0, 1, 2]}
                              //     tasks={server}
                              //   />
                              )
                            }
                          ]}
                        />
                      </GridContainer>

                    </GridContainer>
                  )
                },
                                              // 3rd Tab
                                              // Smart Sell   
                // {
                //   tabName: "Smart Sell",
                //   // tabIcon: LibraryBooksIcon,
                //   tabContent: (
                    
                //   )
                // },
                                                  // 4th tab
                                                //  Smart Cover Tab
                // {
                //   tabName: "Smart Cover",
                //   // tabIcon: LockIcon,
                //   tabContent: (
                   
                //   )
                // },
                                              // 5th tab
                                              // Smart Buy tab
                // {
                //   tabName: "Smart Buy",
                //   // tabIcon: LockIcon,
                //   tabContent: (
                    
                //   )
                // },
              ]}
            />
          </GridItem>
        </GridContainer>         

        
        {/* <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Used Space</p>
              <h3 className={classes.cardTitle}>
                49/50 <small>GB</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  Get more space
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Revenue</p>
              <h3 className={classes.cardTitle}>$34,245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Last 24 Hours
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Icon>info_outline</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Fixed Issues</p>
              <h3 className={classes.cardTitle}>75</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />
                Tracked from Github
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Followers</p>
              <h3 className={classes.cardTitle}>+245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Just Updated
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}


      </GridContainer>

      
    </div>
  );
}